import React from 'react';
import PropTypes from 'prop-types';
import { listenForSpacebar } from '../../../../common/helpers/accessibility';

import './BoxedCheckbox.scss';
import Loader from '../loader/Loader';

const BoxedCheckbox = ({ onChange, children, checked, inputId, isLoading }) => {
	return (
		<label
			className="boxed-checkbox__wrapper"
			tabIndex={0}
			onFocus={() => window.addEventListener('keyup', listenForSpacebar, true)}
			onBlur={() => window.removeEventListener('keyup', listenForSpacebar, true)}
		>
			{isLoading ? (
				<Loader />
			) : (
				<>
					<input
						id={inputId}
						className="boxed-checkbox__input"
						type="checkbox"
						defaultChecked={checked}
						onChange={onChange}
					/>
					<span className="boxed-checkbox__element" />
				</>
			)}
			<div className="boxed-checkbox__content">{children}</div>
		</label>
	);
};

BoxedCheckbox.propTypes = {
	onChange: PropTypes.func.isRequired,
};

export default BoxedCheckbox;
